import React from 'react';
import { OfferBar } from './components/OfferBar';
import { Hero } from './components/Hero';
import { Stats } from './components/Stats';
import { Testimonials } from './components/Testimonials';
import { PainPoints } from './components/PainPoints';
import { PromptExplainer } from './components/PromptExplainer/PromptExplainer';
import { Volumes } from './components/Volumes';
import { Bonuses } from './components/Bonuses';
import { Pricing } from './components/Pricing';
import { FAQ } from './components/FAQ';
import { ValueStack } from './components/ValueStack';
import { Footer } from './components/Footer';
import { MetaPixel } from './components/MetaPixel';
export function App() {
  return <div className="min-h-full w-full overflow-x-hidden text-plum" data-id="element-0" data-mp="2wjqhr811w6n6">
      <MetaPixel data-id="element-1" data-mp="28ufp6dtutik4" />
      <OfferBar data-id="element-2" data-mp="28tw62tsgwo4i" />
      {/* Spacer matching the fixed offer bar height */}
      <div className="h-[58px] sm:h-[68px]" aria-hidden="true" style={{
      paddingBottom: "29px"
    }} data-id="element-3" data-mp="28s2z1ddy01vz" />
      <main data-id="element-4" data-mp="23ti67z10skhk">
        <Hero data-id="element-5" data-mp="3ik7g4ghnibqn" />
        <Stats data-id="element-6" data-mp="3ikh5q2ysagvt" />
        <Testimonials data-id="element-7" data-mp="3iiwg8rrbto4t" />
        <PainPoints data-id="element-8" data-mp="3ijpcgysnsv8p" />
        <Volumes data-id="element-9" data-mp="3ii4r9zs8ioni" />
        <Bonuses data-id="element-10" data-mp="3mlayb9n68jv1" />
        <Pricing data-id="element-11" data-mp="3mkrc3gqhn9b7" />
        <PromptExplainer data-id="element-12" data-mp="3mk85gw6ag7ch" />
        <FAQ data-id="element-13" data-mp="3mjga9mglsbmq" />
        <ValueStack data-id="element-14" data-mp="3mj6lu3b7icj5" />
      </main>
      <Footer data-id="element-15" data-mp="3rbzomln47asl" />
    </div>;
}